<template>
  <a-modal
    :wrapClassName="disabeld ? 'ps-see-form-modal' : ''"
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="handleSubmit"
    :ok-text="saveText"
    :cancel-text="isReadonly ? '关闭' : '取消'"
    :destroyOnClose="true"
    :ok-button-props="isReadonly ? { style: { display: 'none' } } : {}"
  >
    <a-form-model
      ref="formRef"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="名称" prop="achievementName">
        <a-select
          v-model="form.achievementName"
          placeholder="请选择名称"
          @change="handleAchievementChange"
          :disabled="isReadonly"
        >
          <a-select-option
            v-for="item in brandAchievementsList"
            :key="item.value"
            :value="item.text"
          >
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 通用字段 -->
      <a-form-model-item label="数量" prop="achievementNum">
        <a-input-number
          v-model="form.achievementNum"
          :min="1"
          :precision="0"
          style="width: 100%"
          placeholder="请输入数量"
          :disabled="isReadonly"
        />
      </a-form-model-item>

      <!-- 教改项目 -->
      <template v-if="form.achievementName == '教改'">
        <a-form-model-item label="项目名称" prop="name">
          <a-input
            v-model="form.name"
            style="width: 100%"
            placeholder="请输入项目名称"
            :disabled="isReadonly"
          />
        </a-form-model-item>
        <a-form-model-item label="立项单位" prop="achievementDepart">
          <a-input
            v-model="form.achievementDepart"
            style="width: 100%"
            placeholder="请输入立项单位"
            :disabled="isReadonly"
          />
        </a-form-model-item>
        <a-form-model-item label="立项时间" prop="achievementStartTime">
          <a-date-picker
            v-model="form.achievementStartTime"
            :format="'YYYY-MM-DD'"
            style="width: 100%"
            placeholder="请选择立项时间"
            :disabled="isReadonly"
            inputReadOnly
          />
        </a-form-model-item>
        <a-form-model-item label="项目级别" prop="achievementLevel">
          <a-select
            v-model="form.achievementLevel"
            placeholder="请选择项目级别"
            :disabled="isReadonly"
          >
            <a-select-option
              v-for="level in levelList"
              :key="level.value"
              :value="level.text"
            >
              {{ level.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="结项时间" prop="achievementEndTime">
          <a-date-picker
            v-model="form.achievementEndTime"
            :format="'YYYY-MM-DD'"
            style="width: 100%"
            placeholder="请选择结项时间"
            :disabled="isReadonly"
            inputReadOnly
          />
        </a-form-model-item>
        <a-form-model-item label="资助金额" prop="fundingAmount">
          <div class="flex">
            <a-input-number
              v-model="form.fundingAmount"
              :min="0"
              :precision="2"
              style="width: 100%"
              placeholder="请输入资助金额"
              :disabled="isReadonly"
            />
            <span class="surplus-money">元 </span>
          </div>
        </a-form-model-item>
      </template>

      <!-- 课程申报 -->
      <template v-else-if="form.achievementName == '课程申报'">
        <a-form-model-item label="课程名称" prop="name">
          <a-input
            v-model="form.name"
            style="width: 100%"
            placeholder="请输入课程名称"
            :disabled="isReadonly"
          />
        </a-form-model-item>
        <a-form-model-item label="认定级别" prop="achievementLevel">
          <a-select
            v-model="form.achievementLevel"
            placeholder="请选择认定级别"
            :disabled="isReadonly"
          >
            <a-select-option
              v-for="level in levelList"
              :key="level.value"
              :value="level.text"
            >
              {{ level.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="认定时间" prop="achievementStartTime">
          <a-date-picker
            v-model="form.achievementStartTime"
            :format="'YYYY-MM-DD'"
            style="width: 100%"
            placeholder="请选择认定时间"
            :disabled="isReadonly"
            inputReadOnly
          />
        </a-form-model-item>
      </template>

      <!-- 教学成果 -->
      <template v-else-if="form.achievementName == '教学成果'">
        <a-form-model-item label="成果名称" prop="name">
          <a-input
            v-model="form.name"
            style="width: 100%"
            placeholder="请输入成果名称"
            :disabled="isReadonly"
          />
        </a-form-model-item>
        <a-form-model-item label="级别" prop="achievementLevel">
          <a-select
            v-model="form.achievementLevel"
            placeholder="请选择级别"
            :disabled="isReadonly"
          >
            <a-select-option
              v-for="level in levelList"
              :key="level.value"
              :value="level.text"
            >
              {{ level.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="时间" prop="achievementStartTime">
          <a-date-picker
            v-model="form.achievementStartTime"
            style="width: 100%"
            placeholder="请选择时间"
            :disabled="isReadonly"
            inputReadOnly
          />
        </a-form-model-item>
      </template>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/index";
import moment from "moment";
// 常量定义
const DICT_CODE = "brand_achievements";
const SPECIAL_ACHIEVEMENT_TYPES = ["教改", "课程申报", "教学成果"];

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },

      form: {
        id: "",
        applyId: "",
        achievementName: "",
        achievementNum: null,
        name: "",
        achievementDepart: "",
        achievementStartTime: null,
        achievementLevel: "",
        achievementEndTime: null,
        fundingAmount: null,
      },

      rules: {
        achievementName: [
          { required: true, message: "请选择名称", trigger: "change" },
        ],
        achievementNum: [
          { required: true, message: "请输入数量", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        achievementDepart: [
          { required: true, message: "请输入立项单位", trigger: "blur" },
        ],
        achievementStartTime: [
          { required: true, message: "请选择时间", trigger: "change" },
        ],
        achievementLevel: [
          { required: true, message: "请选择级别", trigger: "change" },
        ],
        achievementEndTime: [
          { required: true, message: "请选择时间", trigger: "change" },
        ],
        fundingAmount: [
          { required: true, message: "请输入资助金额", trigger: "blur" },
        ],
      },

      applyType: 2,
      mode: "", // 'add' or 'edit'
      title: "",
      brandAchievementsList: [],
      levelList: [],
      disabeld: false,
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
    };
  },

  computed: {
    isReadonly() {
      return (
        this.disabeld ||
        this.mode === "see" ||
        this.mode === "view" ||
        this.mode === "preview"
      );
    },
  },

  methods: {
    // 初始化模态框
    init(mode, record, taskId, detailId) {
      this.mode = mode;
      this.disabeld = false;
      this.saveText = "保存";
      this.visible = true;
      this.resetForm();
      this.loadDictData();

      if (mode === "add") {
        this.title = "新增品牌成果";
        this.form.applyId = record.id;
      } else if (mode === "edit") {
        this.title = "编辑品牌成果";
        // 合并所有字段，确保编辑时能正确显示原有数据
        this.form = {
          ...this.form,
          ...record,
          id: record.id,
          applyId: record.applyId,
          achievementName: record.achievementName,
          achievementNum: record.achievementNum,
        };
        this.teacherdata = record;
      } else if (mode === "audit-edit") {
        this.title = "编辑品牌成果";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        // 合并所有字段，确保编辑时能正确显示原有数据
        this.form = {
          ...this.form,
          ...record,
          id: record.id,
          applyId: record.applyId,
          achievementName: record.achievementName,
          achievementNum: record.achievementNum,
        };
      } else {
        this.disabeld = true;
        this.title = "查看品牌成果";
        this.saveText = "关闭";
        this.form = {
          ...this.form,
          ...record,
          id: record.id,
          applyId: record.applyId,
          achievementName: record.achievementName,
          achievementNum: record.achievementNum,
        };
      }
    },

    // 处理成果类型变化
    handleAchievementChange() {
      // 重置特定字段的验证状态
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      });
    },

    // 加载字典数据
    async loadDictData() {
      try {
        const [brandRes, levelRes] = await Promise.all([
          getAction(`/baseCommon/getDictItemsByCode?code=${DICT_CODE}`),
          getAction("/baseCommon/getDictItemsByCode?code=achievement_level"),
        ]);

        if (brandRes.code === 200) {
          this.brandAchievementsList = brandRes.result;
        }
        if (levelRes.code === 200) {
          this.levelList = levelRes.result;
        }
      } catch (error) {
        console.error("加载字典数据失败:", error);
        this.$message.error("加载字典数据失败");
      }
    },

    // 重置表单
    resetForm() {
      this.form = {
        id: "",
        applyId: "",
        achievementName: "",
        achievementNum: null,
        name: "",
        achievementDepart: "",
        achievementStartTime: null,
        achievementLevel: "",
        achievementEndTime: null,
        fundingAmount: null,
      };
      this.$refs.formRef?.clearValidate();
    },

    // 构建提交参数
    buildSubmitParams() {
      const baseParams = {
        id: this.form.id,
        applyId: this.form.applyId,
        applyType: this.applyType,
        type: this.form.achievementName,
        num: this.form.achievementNum,
        achievementName: this.form.achievementName,
        achievementNum: this.form.achievementNum,
      };

      // 根据不同类型添加特定字段
      switch (this.form.achievementName) {
        case "教改":
          return {
            ...baseParams,
            name: this.form.name,
            achievementDepart: this.form.achievementDepart,
            achievementStartTime: moment(this.form.achievementStartTime).format(
              "YYYY-MM-DD"
            ),
            achievementLevel: this.form.achievementLevel,
            achievementEndTime: moment(this.form.achievementEndTime).format(
              "YYYY-MM-DD"
            ),
            fundingAmount: this.form.fundingAmount,
          };
        case "课程申报":
          return {
            ...baseParams,
            name: this.form.name,
            achievementLevel: this.form.achievementLevel,
            achievementStartTime: moment(this.form.achievementStartTime).format(
              "YYYY-MM-DD"
            ),
          };
        case "教学成果":
          return {
            ...baseParams,
            name: this.form.name,
            achievementLevel: this.form.achievementLevel,
            achievementStartTime: moment(this.form.achievementStartTime).format(
              "YYYY-MM-DD"
            ),
          };
        default:
          return baseParams;
      }
    },

    // 提交表单
    async handleSubmit() {
      if (this.disabeld) {
        this.visible = false;
        return;
      }
      try {
        await this.$refs.formRef.validate();
        this.confirmLoading = true;

        const params = this.buildSubmitParams();
        let apiUrl =
          this.mode === "add"
            ? "/lxbase/lxBrandAchievements/add"
            : this.mode === "edit"
            ? "/lxbase/lxBrandAchievements/edit"
            : "/audit/lxAuditTask/reSubmitTask";
        if (
          this.teacherdata?.status == "0" ||
          this.teacherdata?.status == "1" ||
          this.teacherdata?.status == "4" ||
          this.teacherdata?.status == "3" ||
          (this.teacherdata?.status == "2" && this.teacherdata?.operation)
        ) {
          apiUrl = "/audit/lxAuditTask/editTaskAndDetail";
        }

        const action = this.mode === "edit" ? putAction : postAction;
        const auditParams = {
          taskId: this.taskId,
          afterJson: JSON.stringify({ ...this.buildSubmitParams() }),
          detailId: this.detailId,
        };
        let auditParams1 = {
          id: this.teacherdata?.taskId,
          applicationData: JSON.stringify(this.$nullToEmpty(params)),
        };
        if (this.teacherdata?.status == "4") {
          auditParams1.auditState = "1";
        }
        let res = "";
        if (
          this.teacherdata?.status == "0" ||
          this.teacherdata?.status == "1" ||
          this.teacherdata?.status == "4" ||
          this.teacherdata?.status == "3" ||
          (this.teacherdata?.status == "2" && this.teacherdata?.operation)
        ) {
          res = await action(apiUrl, auditParams1);
        } else {
          res = await action(
            apiUrl,
            this.mode === "audit-edit" ? auditParams : params
          );
        }

        // const res = await action(
        //   apiUrl,
        //   this.mode === "audit-edit" ? auditParams : params
        // );

        if (res.code === 200) {
          this.$message.success(res.message || `${this.title}成功`);
          this.visible = false;
          this.$emit("addAchievement");
        } else {
          this.$message.error(res.message || `${this.title}失败`);
          this.visible = false;
        }
      } catch (error) {
        if (error.errorFields) {
          this.$message.warning("请完善表单信息");
        } else {
          console.error("提交失败:", error);
          this.$message.error("提交失败，请稍后重试");
        }
      } finally {
        this.confirmLoading = false;
      }
    },

    // 取消
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.surplus-money {
  width: 200px;
  display: inline-block;
  margin-left: 12px;
}
</style>